import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../weight/lots/WeightLots.css';

const LotNavRow = ({ label, summary, to, state }) => {
  const navigate = useNavigate();
  return (
    <div className="wld-nav-row" onClick={() => navigate(to, state ? { state } : undefined)}>
      <span className="wld-nav-label">{label}</span>
      <div className="wld-nav-right">
        {summary != null && <span className="wld-nav-summary">{summary}</span>}
        <span className="wld-nav-chevron">›</span>
      </div>
    </div>
  );
};

export default LotNavRow;
